import { render, staticRenderFns } from "./_sharesBox.vue?vue&type=template&id=b2671c3e&"
import script from "./_sharesBox.vue?vue&type=script&lang=js&"
export * from "./_sharesBox.vue?vue&type=script&lang=js&"
import style0 from "./_sharesBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports